module.exports = __webpack_public_path__ + "static/img/title-5.1903cda8.svg";